import { Component } from 'react';
import { connect } from 'react-redux';
import { getDisplayName, getIsModuleEditable } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { BaseResponsiveHeaderToolbar, buildHeaderActions } from './BaseResponsiveHeaderToolbar';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
// @ts-expect-error Untyped module
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error Untyped module
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
import { getContentModelHeaderVariantName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  let newProps = {};
  if (ownProps.id) {
    newProps = {
      displayName: getDisplayName(state, ownProps.id),
      isEditable: getIsModuleEditable(state, ownProps.id),
      selectedItemId: getSelectedItemId(state)
    };
  }
  newProps.isInNonDefaultBreakpointMode = getIsInNonDefaultBreakpointMode(state);
  newProps.variantName = getContentModelHeaderVariantName(state);
  return newProps;
};
class ResponsiveHeaderToolbar extends Component {
  render() {
    const {
      id,
      displayName,
      top,
      left,
      onDropdownOpenChange,
      responsiveSize = DEFAULT_RESPONSIVE_SIZE,
      dispatch,
      bus,
      isEditable,
      isInNonDefaultBreakpointMode,
      variantName
    } = this.props;
    const handleDropdownOpenChange = isOpen => {
      if (onDropdownOpenChange) {
        onDropdownOpenChange(isOpen);
        if (isOpen) {
          bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.EDIT_HEADER));
        }
      }
    };
    return /*#__PURE__*/_jsx(BaseResponsiveHeaderToolbar, {
      actions: buildHeaderActions({
        moduleId: id,
        isInNonDefaultBreakpointMode,
        dispatch,
        bus,
        isEditable: !!isEditable,
        variantName
      }),
      onDropdownOpenChange: handleDropdownOpenChange,
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`,
      position: "absolute",
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      iconUse: "pinned"
    });
  }
}
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveHeaderToolbar);